import React, { useState, useEffect } from "react";
import CentralizedModalContainer from "@/appComponents/Blocks/Utils/CentralizedModalContainer/CentralizedModalContainer";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Modal,
  Flex,
  Divider,
  Input,
  Alert,
  TextArea
} from "@theorgchartdev/storybook";
import { GetWSMgr } from "@/Utils/StateLib";
import { usePlanManagerContext } from "@/providers/PlanManagerProvider";
import { appstr } from "@coreapp/utils/appstr";
import { usePlanSubmission } from "@/hooks/usePlanSubmission";
import {
  PlanInfoSection,
  ReviewersSection,
  SubmissionInfoSection,
  PlanDetailsGrid
} from "../PlanSubmissionDetails/PlanSubmissionDetails";
import PlanDetailsSummaryCard from "@/appComponents/Blocks/Composites/PlanDetailsSummaryCard/PlanDetailsSummaryCard";

export const PlanWithdrawModal = () => {
  const {
    planWithdrawContextValue: { showWithdrawModal, closeWithdrawModal }
  } = usePlanManagerContext();

  const { withdrawPlanSubmission } = usePlanSubmission();

  const [message, setMessage] = useState("");

  const { planManager } = usePlanManagerContext();
  const planSubmission = planManager?.state?.GetPlanSubmission();

  useEffect(() => {
    if (!showWithdrawModal) {
      setMessage("");
    }
  }, [showWithdrawModal]);

  if (!showWithdrawModal || !planSubmission) return null;

  const wsMgr = GetWSMgr();
  const planMgr = wsMgr?.fPlanManager;
  const planInfo = planMgr?.GetPlanInfo();

  const handleWithdraw = () => {
    withdrawPlanSubmission(message);
    closeWithdrawModal();
  };

  return (
    <CentralizedModalContainer show={showWithdrawModal}>
      <Modal
        id="plan-withdraw-modal"
        show={showWithdrawModal}
        onClose={closeWithdrawModal}
        minWidth={"medium"}
        maxWidth={"medium"}
        withShadow={true}
        centerScreen={true}
      >
        <DialogTitle divider={true} onClose={closeWithdrawModal}>
          {appstr("Withdraw plan")}
        </DialogTitle>
        <DialogContent customContentClass={"oc-modal-content"}>
          <Flex direction={"column"} gap={"16px"} height={"100%"}>
            <Alert severity={"info"}>{appstr("Withdraw plan info message")}</Alert>
            <PlanDetailsSummaryCard>
              <PlanDetailsGrid>
                <PlanInfoSection planInfo={planInfo} />
                <SubmissionInfoSection submission={planSubmission.submission} />
              </PlanDetailsGrid>
            </PlanDetailsSummaryCard>
            <ReviewersSection reviewers={planSubmission.reviewers} />
            <Divider />
            <TextArea
              id="plan-withdraw-message"
              dataTestId="plan-withdraw-message"
              placeholder={appstr("Optional message")}
              value={message}
              onChange={e => setMessage(e.target.value)}
              rows={4}
              charLimit={1000}
              label={appstr("Withdrawal message")}
            />
          </Flex>
        </DialogContent>
        <DialogActions divider={true}>
          <DialogActions.Tertiary
            dataTestId="planning-toolbar-plan-withdraw-cancel-btn"
            onClick={closeWithdrawModal}
          >
            {appstr("Cancel")}
          </DialogActions.Tertiary>
          <DialogActions.Primary
            dataTestId="planning-toolbar-plan-withdraw-confirm-btn"
            onClick={handleWithdraw}
          >
            {appstr("Withdraw plan")}
          </DialogActions.Primary>
        </DialogActions>
      </Modal>
    </CentralizedModalContainer>
  );
};
